import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ApiService } from 'src/app/api.service';
import { CookieTovpil } from 'src/app/shared/models/CookieTovpil';
import { UserPreferences } from 'src/app/shared/models/UserPreferences';
import { Constants } from 'src/app/shared/vo/Constants';
import { TovpilCookieService } from 'src/app/utils/tovpil-cookie.service';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { UserPreferencesService } from 'src/app/utils/user-preferences.service';
import { FiiDtl, jrnH } from 'src/app/shared/models/FiiDtl';
import { off } from 'process';

@Component({
  selector: 'app-jrnh-guide-refer-exp',
  templateUrl: './jrnh-guide-refer-exp.component.html',
  styleUrls: ['./jrnh-guide-refer-exp.component.scss'],
  providers: [MessageService, ConfirmationService, TovpilLanguageService]
})
export class JrnhGuideReferExpComponent implements OnInit {

  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};
  globalUserDataForm: FormGroup;
  //offerTreasureDataForm: FormGroup;

  /** COMPONENT */
  languages: any[];
  periods: any[];
  currencies: any[];
  selStoreId: string;

  /** PIPES */
  datePipe: DatePipe = new DatePipe('en-US');

  /** LABELS */
  translations: Record<string, string> = {};

  /** COMPONENT OVERLAY */
  blocked: boolean = true;

  dataO: Record<string, any>[];
  colsO: any[];
  rowsO: number = 10;
  colsGlI = ['docId', 'date', 'amount', 'concept'];
  colsFiI = [
    { name: 'Id', value: 'docId' },
    { name: 'Servicio', value: 'descSerType' },
    { name: 'Día', value: 'descWeekDay' },
    { name: 'Hora', value: 'fromTime' },
    { name: 'Fecha', value: 'dateWF' },
    { name: 'Monto', value: 'amount' },
    { name: 'Comentarios', value: 'concept' },
    { name: 'Sobres', value: 'checkNum' }
  ];

  /** DATAPARENT */
  dataParent: any = {};

  /**MODAL FLAG */
  displayModalOfferExists: boolean = false;
  offerExists: jrnH = {}
  listWorkShopsByGuide: any[];
  selectedWorkShopsByGuide: any;
  selectedOffer: any;

  /** ENDPOINTS */

  endPointGuideId = "getGuideById";
  endPointLanguageByStoreId = "getListSpkLangByStoreId";
  endPointGetValidPeriods = "getValidPeriods";
  endPointGetCurrencyByStoreId = "getListCurrencyByStoreId";
  endPointGetStoreById = "getStoreById";
  endPointGetJrnHGuideReferIncExpId = "jrnHGuideReferIncExp";
  endPointCrudJrnhOffer = "crudJrnhOffer";
  endPointFindPeriodGuideDescrip = "findPeriodGuideDescrip";

  constructor(
    private messageService: MessageService,
    private apiService: ApiService,
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private tovpilCrudService: TovpilCrudService,
    private filesService: TovpilFilesService,
    private router: Router,
    private cookieService: TovpilCookieService,
    private userPreferencesService: UserPreferencesService,
    private translationService: TovpilLanguageService,
    private route: ActivatedRoute,
    private tovpilUtils: TovpilUtilsService,
    private confirmationService: ConfirmationService,
  ) {
    this.createDataForm();
    this.initConfigs();

    // DATAPARENT 
    this.route.queryParams.subscribe(params => {
      // Asigna los valores de queryParams a las propiedades de dataParent
      this.dataParent.guideId = params.guideId;
      this.dataParent.storeId = params.storeId;
    });
  }

  ngOnInit(): void {
    const currentUser = this.authenticationService.currentUserValue;
    //this.getSecurity();
    this.getTranslatedLabels();
  }

  /**
   * The function `getSecurity()` retrieves security data and performs additional actions if the data is
   * not already available.
   */
  async getSecurity() {
    const securityControl = this.globalUserPreferences || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE Y TENTATIVAMENTE SE PUEDE ELIMINAR ESTOS BLOQUES
    if (!securityControl) {
      const tokenProfile = this.globalUserPreferences?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences = data;
    }

    this.getTranslatedLabels();
  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * .
   */
  async getTranslatedLabels() {
    const language = this.globalUserPreferences?.preferences?.language || null;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
      //await this.getLanguages();
      await this.getInitData();
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      this.messageService.add({ severity: 'warn', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga ETIQUETAS, inténtelo más tarde' });
    }
  }

  /**
   * The `getInitData` function fetches price list data, selected price data, and exchange rate data,
   * and then updates the form with the fetched data.
   */
  async getInitData() {

    try {
      const language = this.globalUserPreferences?.preferences?.language || null;

      if (this.dataParent.storeId != null && (this.dataParent.storeId === this.globalUserPreferences?.preferences?.coordinationId)) {
        this.globalUserPreferences.preferences.coordinationId = this.dataParent.storeId
      }


      //const currency = this.globalUserPreferences?.preferences?.selCurrency || null;
      //const period = this.globalUserPreferences?.preferences?.periodSelected || null;
      const guideId = this.dataParent.guideId || null
      const storeId = this.globalUserPreferences?.preferences?.coordinationId || this.globalUserPreferences?.preferences?.storeId || null;

      const validCoordinationResponse = await this.getCoordination(storeId);
      const validGuideResponse = await this.getValidGuide(guideId);
      const validPeriodsResponse = await this.getValidPeriods(language);

      if (validGuideResponse && validCoordinationResponse && validPeriodsResponse) {
        await this.loadData();
      } else {
        console.error("An error occurred while fetching :", validGuideResponse);
        this.handleError('JrnhGuideReferExpComponent', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      }

    } catch (error) {
      console.error("An error occurred while fetching price list:", error);
      this.handleError('JrnhGuideReferExpComponent', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    }
  }

  /**
   * The `loadData` function is an asynchronous function that loads data from an API and displays a
   * message based on the validity of the form data.
   * @returns nothing.
   */
  async loadData() {

    if (!this.globalUserDataForm.valid) {
      this.handleError('JrnhGuideReferExpComponent', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      return;
    }
    try {
      this.blocked = true;

      const guideId = this.dataParent.guideId || null
      const storeId = this.globalUserPreferences?.preferences?.coordinationId || this.globalUserPreferences?.preferences?.storeId || null;

      const language = this.globalUserPreferences?.preferences?.language || null;
      const period = this.globalUserDataForm.get('selectedPeriod').value.period || null;
      const year = this.globalUserDataForm.get('selectedPeriod').value.year || null;

      const offersResponse = await this.getListJrnHGuideReferIncExpId(guideId, year, period, language);
      ////const incomeResponse = await this.getListIncome(period, year, language);
      ////const outcomeResponse = await this.getListOutcome(period, year, language);

      // OBTENEMOS LISTA DE SERVICIOS
      const workshopLstResponse = await this.getWorkShopsLst();

      /////if (amountResponse && incomeResponse && outcomeResponse) {
      if (offersResponse) {

        this.blocked = false;
      } else {
        this.handleError('JrnhGuideReferExpComponent', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
      this.handleError('JrnhGuideReferExpComponent', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    } finally {
      setTimeout(() => {
      }, 1500);
    }
  }

  /**
   * The function `getListReferInc` is an asynchronous function that fetches data from an API endpoint and
   * handles the success and error cases.
   * @returns a Promise.
   */
  async getListJrnHGuideReferIncExpId(guideId: string, year: string, period: string, language: string) {
    try {
      return new Promise((resolve, reject) => {
        this.tovpilCrudService.fetch(this.endPointGetJrnHGuideReferIncExpId, {
          guideId: guideId,
          year: year,
          period: period,
          language: language,
          type: "OI"
        }).then(result => {
          if (result.success) {
            this.handleSuccessJrnHGuideReferIncExpId(result.data);
            resolve(true);
          } else {
            console.error("An error occurred while fetching purchase order data:");
            this.handleError('JrnhGuideReferExpComponent', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
            resolve(false);
          }
        }).catch(error => {
          console.error(error);
          reject(error);
        });
      });
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function `crudJrnHOfferIncExpId` is an asynchronous function that fetches data from an API endpoint and
   * handles the success and error cases.
   * @returns a Promise.
   */
  async crudJrnHOfferIncExpId(language: string, method: string, jrnH: jrnH) {
    try {
      jrnH.conType = 'I';
      jrnH.status = 'A';
      
      if (this.selectedWorkShopsByGuide) {
        jrnH.docRefer = this.selectedWorkShopsByGuide.form0?.wrksId;
        console.log("selectedworkshps:" , this.selectedWorkShopsByGuide);
      } else {
        if (jrnH.month > '06') {
          jrnH.docRefer = jrnH.year + '_2';
        } else {
          jrnH.docRefer = jrnH.year + '_1';
        }
      }
      return new Promise((resolve, reject) => {
        this.tovpilCrudService.fetch(this.endPointCrudJrnhOffer, {
          jrnH: jrnH,
          language: language,
          method: method
        }).then(result => {
          if (result.success) {
            console.log(result.data);
            this.handleSuccessCrudJrnHOffer(result.data);
            resolve(true);
          } else {
            console.error("An error occurred while fetching purchase order data:");
            this.handleError('JrnhGuideReferExpComponent', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
            resolve(false);
          }
        }).catch(error => {
          console.error(error);
          reject(error);
        });
      });
    } catch (error) {
      console.error(error);
      return false;
    }
  }




  /**
   * The function "handleSuccessLstAmount" handles the success response of a data retrieval operation and
   * updates the necessary variables and properties accordingly.
   * @param {any[]} data - An array of objects containing the data to be processed.
   */
  async handleSuccessJrnHGuideReferIncExpId(data: any[]) {

    if (data.length > 0) {

      //this.datePipe.transform(this.tovpilUtils.convertStringToDate(dateString), 'yyyy-MM-dd');

      //agregamos columna total
      const newData = data.map(o => ({ ...o, dateWF: this.datePipe.transform(this.tovpilUtils.convertStringToDate(o.date), 'yyyy-MM-dd') }));
      //console.log(newData);

      this.colsO = this.tovpilCrudService.extractColumns(newData[0], undefined, this.colsFiI);
      // Asignar los datos al arreglo de productos


      this.dataO = newData;
      // Asignar el número de filas por página dinámicamente
      ////this.rowsFII = this.tovpilCrudService.calculateRowsPerPage(data.length, this.rowsFII);
    } else if (data.length === 0) {
      this.dataO = [];
      // this.messageService.add({ severity: 'warn', summary: 'jrnHGuideReferIncExp', detail: 'No existen registros' });
    } else {
      /*this.dataFII = null;
      this.colsFII = null;*/
      this.handleError('JrnhGuideReferExpComponent', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    }
  }

  /**
   * The function "handleSuccessCrudJrnHOffer" handles the success response of a data retrieval operation and
   * updates the necessary variables and properties accordingly.
   * @param {any[]} data - An array of objects containing the data to be processed.
   */
  async handleSuccessCrudJrnHOffer(data: FiiDtl) {

    if (data) {
      if (data.status != "OK") {
        this.handleError('JrnhGuideReferExpComponent', data.errorMessage);
        return;
      }
      this.offerExists = data.jrnH;


      switch (data.method) {
        case "GET":
          let dateWorkShop = this.tovpilUtils.dateToTovpilDate2(this.offerExists.year + "/" + this.offerExists.month + "/" + this.offerExists.day);
          this.offerExists.fullDate = dateWorkShop;
          break;
        case "CREATE":
          this.displayModalOfferExists = false;
          this.loadData();
          this.messageService.add({ severity: 'success', summary: 'JrnhGuideReferExpComponent', detail: 'Se guardo correctamente' });
          break;
        case "UPDATE":
          this.displayModalOfferExists = false;
          this.loadData();
          this.messageService.add({ severity: 'success', summary: 'JrnhGuideReferExpComponent', detail: 'Se actualizo correctamente' });
          break;
        case "DELETE":
          console.log("PROCESAR DELETE");
          this.loadData();
          this.messageService.add({ severity: 'success', summary: 'JrnhGuideReferExpComponent', detail: 'Se elimino correctamente' });
          this.offerExists = {};
          console.log(this.dataO);
          break;
      }

    } else {

      this.handleError('JrnhGuideReferExpComponent', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    }
  }

  /**
   * The handleError function handles errors by displaying a message and navigating back.
   * @param {string} summary - Summary is a brief description or title of the error that occurred. It
   * helps to provide a quick overview of what went wrong.
   * @param {string} detail - The `detail` parameter in the `handleError` function is a string that
   * provides additional information or details about the error that occurred. It is meant to give more
   * context or explanation about the error to help users understand what went wrong.
   */
  private handleError(summary: string, detail: string) {
    console.error("An error occurred while parsing.");
    this.messageService.add({
      severity: 'error',
      summary: summary,
      detail: detail,
      life: 5000
    });
  }

  /**
    * The function `createDataForm` in TypeScript initializes a form group with various form controls and
    * default values, as well as setting some controls as disabled.
    */
  createDataForm() {
    this.globalUserDataForm = this.fb.group({
      selectedLanguage: new FormControl({ value: null }),
      selectedPeriod: new FormControl({ value: null, disabled: true }),
      selectedCurrency: new FormControl({ value: null }),
      selectedCoordination: new FormControl({ value: null, disabled: true }),
      selectedGuide: new FormControl({ value: null, disabled: true }),
      selectedWorkshop: new FormControl({ value: null, disabled: true }),
      selectedSchedule: new FormControl({ value: null, disabled: true }),
    });
  }

  /**
    * The function initializes form groups for configuration and data, and updates the configuration form
    * with query parameters from the route.
    */
  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferences = await this.userPreferencesService.getSantovTovpilCookie() || null;
    //console.debug("JrnhGuideReferExpComponent() Preferencuas de usuario: " + JSON.stringify(this.globalUserPreferences, null, 2));
    //this.selStoreId=Constants.selStore.storeId;
  }

  /**
     * The function "capitalizeLastElement" takes a string as input and returns the same string with the
     * last element capitalized.
     * @param {string} str - The parameter `str` is a string that represents the input string.
     * @returns the result of calling the `capitalizeLastElement` method of the `tovpilCrudService` object
     * with the `str` parameter.
     */
  capitalizeLastElement(str: string): string {
    return this.tovpilCrudService.capitalizeLastElement(str);
  }


  /**
   * The  function fetches valid guide from a service and assigns them to a object, then
   * @returns a boolean value. It returns true if the data retrieval is successful (data.success is
   * true), and false if there is an error or the data retrieval is not successful.
   */
  async getValidGuide(guideId: string) {

    try {

      const data = await this.tovpilCrudService.fetch(this.endPointGuideId, { guideId });

      if (!data.success) {
        this.handleError('JrnhGuideReferExpComponent', 'Hubo un problema al obtener guia. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }


      const guide = data.data || {}; //
      this.globalUserDataForm.patchValue({
        selectedGuide: guide.name + " " + guide.lastName
      });

      return true;
    } catch (error) {
      console.error("Error in getValidPeriods:", error);
      this.handleError('JrnhGuideReferExpComponent', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      return false;
    }
  }

  /**
   * The function asynchronously fetches store data and updates the global user data
   * form with the retrieved information.
   * @returns The function returns a boolean value (`true` or `false`) based on the
   * success of fetching store data and updating the `selectedCoordination` value in the
   * `globalUserDataForm`. If the store data is successfully fetched, it returns `true`. If there is an
   * error during the process, it returns `false`.
   */
  async getCoordination(storeId: string) {
    try {

      if (!storeId) {
        console.warn('Missing required parameters: storeId and languageId are necessary.');
        return false;
      }

      const result = await this.tovpilCrudService.fetch(this.endPointGetStoreById, {
        storeId
      });

      if (result.success) {

        this.globalUserDataForm.patchValue({
          selectedCoordination: result.data?.storeId + ' ' + result.data?.descri
        });
        return true;
      } else {
        console.error("An error occurred while fetching purchase order data:");
        this.handleError('CURRENCY Lista', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The  function fetches valid periods from a service and assigns them to a list, then
   * selects a default period and returns a boolean indicating success.
   * @returns a boolean value. It returns true if the data retrieval is successful (data.success is
   * true), and false if there is an error or the data retrieval is not successful.
   */
  async getValidPeriods(language: string) {
    try {

      const data = await this.tovpilCrudService.fetch(this.endPointGetValidPeriods, language);

      if (!data.success) {
        this.handleError('JrnhGuideReferExpComponent', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
      const lstPeriod = data.data || []; // Handle empty data array

      const selPeriod = this.globalUserPreferences?.preferences?.periodSelected ?? null;

      const selectedPeriod = selPeriod?.year
        ? lstPeriod.find(period => period.year === selPeriod.year && period.period === selPeriod.period)
        : lstPeriod[0]; // Default to first period if no selection or year missing

      this.periods = lstPeriod;

      this.globalUserDataForm.patchValue({
        selectedPeriod: selectedPeriod
      });

      return true;
    } catch (error) {
      console.error("Error in getValidPeriods:", error);
      this.handleError('JrnhGuideReferExpComponent', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      return false;
    }
  }

  /**
   * The function `getNestedValue` retrieves a nested value from an object using a specified field.
   * @param {any} obj - The `obj` parameter is an object from which you want to retrieve a nested value.
   * @param {string} field - The `field` parameter is a string that represents the path to a nested value
   * in the `obj` object.
   * @returns The `getNestedValue` function is returning the value of the nested field in the given
   * object.
   */
  getNestedValue(obj: any, field: string): any {
    return this.tovpilCrudService.getNestedValue(obj, field);
  }

  goBack() {
    try {
      try {
        this.router.navigate(['/treasurer/jrnHGuideReferInc'], {});

      } catch (navigationError) {
        console.error("An error occurred while navigating to coordination catalog details:", navigationError);
        this.handleError('Redirigir', 'Algo salio mal al redirigir a CX4');
      }
    } catch (parseError) {
      console.error("An error occurred while parsing state to JSON:", parseError);
      this.handleError('Redirigir', 'Algo salio mal al redirigir');
    }
  }

  async editOrNewOffer(offer: any) {
    this.selectedOffer = offer;
    if (offer) {
      this.offerExists = {
        docId: offer.docId
      };
      const language = this.globalUserPreferences?.preferences?.language || null;
      await this.crudJrnHOfferIncExpId(language, "GET", this.offerExists);
      this.displayModalOfferExists = true;

    } else {
      this.displayModalOfferExists = true;
      this.offerExists = {};
    }
  }

  async confirmDeleteOffer(offer: any) {
    this.selectedOffer = offer;
    this.confirmationService.confirm({
      message: this.translations.lbl_are_you_sure + " " + this.translations.lbl_delete_record + " ?",
      header: this.translations.lbl_confirm + " " + this.translations.lbl_delete_record,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.deleteOffer(offer);
      }
    });
  }


  async deleteOffer(offer: any) {
    console.log("Se confirma eliminar usuario");
    const offerDelete = { docId: offer.docId }
    const language = this.globalUserPreferences?.preferences?.language || null;
    await this.crudJrnHOfferIncExpId(language, "DELETE", offerDelete);

  }

  async createUpdateOffer() {

    const searchRegExp = new RegExp("/", 'g');
    let fullDateN = this.offerExists.fullDate.replace(searchRegExp, "");
    this.offerExists.day = fullDateN.substring(0, 2);
    this.offerExists.month = fullDateN.substring(2, 4);
    this.offerExists.year = fullDateN.substring(4, 8);
    this.offerExists.guideId = (this.dataParent)?.guideId ?? "";

    if (this.selectedWorkShopsByGuide) {
      this.offerExists.storeId = this.selectedWorkShopsByGuide["form0"]?.storeId;
    } else if (!this.offerExists.storeId) {
      this.offerExists.storeId = (this.dataParent)?.storeId ?? "";
    }

    if (!this.offerExists.currCode) {
      this.offerExists.currCode = this.globalUserPreferences?.preferences?.selCurrency || null;
    }

    if (!this.offerExists.status) {
      this.offerExists.status = "A";
    }
    const language = this.globalUserPreferences?.preferences?.language || null;
    if (!this.offerExists.docId) {
      await this.crudJrnHOfferIncExpId(language, "CREATE", this.offerExists);
    } else {
      await this.crudJrnHOfferIncExpId(language, "UPDATE", this.offerExists);
    }

  }

  /**
   * The `exportExcel()` function exports data to an Excel file if the data is not null and not empty,
   * otherwise it displays an error message.
   */
  exportExcel(_data: any[], _colsFilter: any[], _name: string) {
    if (_data === null) {
      this.handleError('FII List', 'Hubo un problema al procesar los FII excel. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    } else if (_data.length < 1) {
      this.handleError('FII List', 'Hubo un problema al procesar los FII excel. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    } else {
      const filteredJSON = _data.map((item) => {
        const dynamicColumns = _colsFilter.map((col) => {
          console.debug(col.value, item);
          return {
            [col.name]: item ? this.tovpilCrudService.getNestedValueDynamic(item, col.value) || 'S/N' : 'S/N'
          };
        });

        return Object.assign({}, ...dynamicColumns);
      });
      this.filesService.tovpilExportXLSX(filteredJSON, _name);
    }
  }

  /**
   * The function `exportPdf` generates a PDF file based on provided data and column filters.
   * @param {any[]} _data - The `_data` parameter is an array containing the data that will be used to
   * generate the PDF. It is expected to be an array of objects where each object represents a row of
   * data to be included in the PDF.
   * @param {any[]} _colsFilter - The `_colsFilter` parameter is an array containing objects with
   * properties `name` and `value`. It is used to filter and map the data in the `_data` array to
   * generate a PDF. Each object in `_colsFilter` specifies a column name and the corresponding value to
   * extract from the data
   * @param {string} _name - The `_name` parameter in the `exportPdf` function is a string that
   * represents the name of the PDF file that will be generated. It is used as a reference to name the
   * PDF file when it is exported.
   */
  exportPdf(_data: any[], _colsFilter: any[], _name: string) {
    if (_data === null || _data.length < 1) {
      this.handleError('FII List', 'Hubo un problema al procesar la información del PDF. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    } else {
      const filteredJSON = _data.map((item) => {
        const dynamicColumns = _colsFilter.map((col) => ({
          [col.name]: item ?
            this.tovpilCrudService.getNestedValueDynamic(item, col.value) || 'S/N' : 'S/N'
        }));
        return Object.assign({}, ...dynamicColumns);
      });
      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));
      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, _name);
    }
  }

  /**
   * This TypeScript function asynchronously fetches workshop data based on selected criteria and handles
   * any errors that may occur.
   * @returns The `getWorkShopsLst` function is returning the data fetched from the `tovpilCrudService`
   * after making a request to the `endPointFindPeriodGuideDescrip`. If the request is successful
   * (`result.success` is true), it returns the `result.data`. If there is an error during the fetch
   * operation, it logs the error and returns null. If the request
   */
  async getWorkShopsLst() {
    try {

      let _storeId = (this.dataParent)?.storeId ?? "";
      let _guideId = (this.dataParent)?.guideId ?? "";
      let _language = this.globalUserPreferences?.preferences?.language || null;
      let _currYear = this.globalUserDataForm.get('selectedPeriod').value.year || null;
      let _currPeriod = this.globalUserDataForm.get('selectedPeriod').value.period || null;

      let result = await this.tovpilCrudService.fetch(this.endPointFindPeriodGuideDescrip, {
        storeId: _storeId || null,
        guideId: _guideId || null,
        currYear: _currYear,
        currPeriod: _currPeriod,
        language: _language,
        zoneId: null
      });

      this.listWorkShopsByGuide = result.data;
      console.log("lista de workshops:" , this.listWorkShopsByGuide);

      if (result.success) {
        return result.data;
      } else {
        console.error("An error occurred while fetching purchase order data:");
        //this.handleError("Hubo un problema, no hay información que procesar. Por favor, recargue la página e inténtelo nuevamente más tarde.");
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  }

}


